import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  header: {
    paddingBottom: theme.new.spacing.medium,
  },
  titleRow: {
    alignItems: 'center',
    gap: theme.new.spacing.small,
  },
  tableWrapper: {
    border: `1px solid ${theme.new.color.line.hairline}`,
    borderStartStartRadius: theme.new.shape.borderRadius.small,
    borderStartEndRadius: theme.new.shape.borderRadius.small,
  },
}));

/** Clears the extra borders the shared table draws against this wrapper. */
export const getTableContainerProps = () => ({
  sx: {
    '& .MuiTable-root .MuiTableHead-root .MuiTableRow-head th.MuiTableCell-head':
      {
        borderTop: 0,
      },
    '& .MuiTableBody-root tr:last-child td': {
      borderBottom: 0,
    },
  },
});

export default useStyles;
